var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.244,
    height: 28.697,
    viewBox: "0 0 28.244 28.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assigned",
    transform: "translate(-128 -128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5087",
    "data-name": "Path 5087",
    d: "M296.37,128a8.37,8.37,0,1,1-8.37,8.37A8.37,8.37,0,0,1,296.37,128Zm0,2.391a5.979,5.979,0,1,0,5.979,5.979A5.979,5.979,0,0,0,296.37,130.391Z",
    transform: "translate(-154.021)",
    fill: "#013182"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5088",
    "data-name": "Path 5088",
    d: "M142.349,512v2.391a11.957,11.957,0,0,0-11.957,11.957H128A14.349,14.349,0,0,1,142.349,512Z",
    transform: "translate(0 -369.651)",
    fill: "#013182"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M520.968,604.128a.6.6,0,0,1,.423.175l1.937,1.938a.6.6,0,0,1,0,.847l-1.937,1.937a.6.6,0,0,1-1.021-.422v-.742H512.6a.6.6,0,0,1-.6-.6v-1.2a.6.6,0,0,1,.6-.6h7.772v-.743A.6.6,0,0,1,520.968,604.128Zm2.391,5.773a.6.6,0,0,1,.423.176l1.937,1.937a.6.6,0,0,1,0,.847l-1.937,1.938a.6.6,0,0,1-1.021-.422v-.744h-7.771a.6.6,0,0,1-.6-.6v-1.2a.6.6,0,0,1,.6-.6h7.772V610.5a.6.6,0,0,1,.6-.6Z",
    transform: "translate(-369.651 -458.337)",
    fill: "#013182"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.71ebc26332482ff3fe185a6c07effe7e.svg";
export { ForwardRef as ReactComponent };